import pathfinder from '@fiverr-private/pathfinder';
import { PATHS, MODES, PATHFINDER, formatQueryParams, getCategorySlug } from '../../utils';
import type { MapperItemConfig } from './types';

export const getCategoryPath = ({ id, mode, queryParams, source }: MapperItemConfig, locale?: string) => {
    if (!id) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const params = { id: getCategorySlug(id, locale) };

    if (mode === MODES.PRO) {
        return pathfinder(PATHFINDER.PRO_CATEGORY, params, formatQueryParams());
    }

    return pathfinder(PATHFINDER.CATEGORY, params, formatQueryParams({ queryParams, source }));
};
